<template>
  <v-app>
    <v-navigation-drawer
       color="secondary"
        v-if="loggedIn"
        v-model="drawer"
        >
      <v-img alt="Top Up Gym Logo" class="my-3 d-none d-sm-flex cursor-pointer" @click="goHome()" width="100%"
             contain :src="logoEsteso" transition="scale-transition" height="64"
      />
      <v-list density="compact" nav slim color="primary" v-model:opened="openGroups">
        <template v-for="page in pages" :key="page.link">
          <v-list-group v-if="page.items" :prepend-icon="page.icon" :value="page.title">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" :title="page.title" :active="areActivePages(page.items)"></v-list-item>
            </template>
            <v-list-item v-for="subpage in page.items" :key="subpage.link" :to="subpage.link" :prepend-icon="subpage.icon" :title="subpage.title" :active="isActivePage(subpage)"></v-list-item>
          </v-list-group>
          <v-list-item v-else :to="page.link" :prepend-icon="page.icon" :title="page.title" :active="isActivePage(page)"></v-list-item>
        </template>

        <v-list-item @click="logout()" prepend-icon="mdi-exit-to-app" title="Esci"></v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <v-app-bar  :color="$vuetify.display.smAndUp ? 'white' : 'secondary'" :density="$vuetify.display.smAndUp ? 'compact':'default'">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="primary"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-img alt="Top Up Gym Logo" class="mr-2 d-sm-none cursor-pointer" @click="goHome()" width="48"
               contain :src="logo" transition="scale-transition" height="48"
        />
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu location="bottom" v-if="loggedIn">
          <template v-slot:activator="{ props }">
            <v-badge :content="numNotifications" :model-value="numNotifications > 0" color="error" overlap class="align-self-center mr-4">
              <v-btn variant="text" :color="numNotifications > 0  ? 'primary' : 'grey-darken-2'" v-bind="props" icon="mdi-bell"></v-btn>
            </v-badge>
          </template>
          <v-list>
            <v-list-item v-for="notif in notifications" :key="notif._id" @click="openNotification(notif)" >
              <template #title>
                <div>
                  <p :class="notificationClass(notif)">{{ notif.text }}</p>
                  <p class="text-grey-darken-2 text-caption">{{ formatDate(notif.time) }}</p>
                </div>
              </template>
            </v-list-item>
            <v-list-item v-if="!notifications.length">
              <v-list-item-title class="body-1 text-grey font-italic no-select">Non ci sono notifiche al momento.</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-dialog v-else v-model="loginDialog" persistent max-width="320">
          <template v-slot:activator="{ props }">
            <v-btn color="primary" variant="text" v-bind="props">Login</v-btn>
          </template>
          <v-form @submit.prevent="onLoginClick">
            <v-card class="pt-3">
              <v-img class="ml-3 mr-3" :src="logoH" transition="scale-transition" />
              <v-card-text>
                <h3 class="headline fw-1 text-uppercase">Login</h3>
                <v-text-field v-model="loginEmail" label="Email"></v-text-field>
                <v-text-field  v-model="loginPassword" label="Password" :type="showPwd ? 'text' : 'password'" :append-inner-icon="showPwd ? 'mdi-eye-off':'mdi-eye'"
                               @click:append-inner="showPwd = !showPwd"></v-text-field>
                <v-btn class="w-100" color="primary" type="submit" :disabled="loginLoading" :loading="loginLoading">Login</v-btn>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar-items>
    </v-app-bar>

    <v-main class="grey lighten-1">

      <router-view v-slot="{ Component }" v-if="loggedIn">
        <v-slide-x-transition >
          <component :is="Component" />
        </v-slide-x-transition>
      </router-view>


      <v-dialog v-model="confirmDialog"  max-width="400">
        <v-card>
          <v-card-title>{{confirmTitle}}</v-card-title>
          <v-card-text>
            <div class="mb-3" v-html="message"></div>

          </v-card-text>
          <v-card-actions >
            <v-checkbox v-if="confirmCheckbox" v-model="confirmCheckboxValue" :label="confirmCheckbox as string" hide-details></v-checkbox>
            <v-spacer/>
            <v-btn variant="text" @click="confirmDialog = false; confirmCheckboxValue = false; confirmCallback(false);"  class="flex-grow-1 flex-shrink-1">Annulla</v-btn>
            <v-btn variant="elevated" color="primary" @click="confirmDialog = false; confirmCheckboxValue = false; confirmCallback(true);" :disabled="!!confirmCheckbox && !confirmCheckboxValue"  class="flex-grow-1 flex-shrink-1">Conferma</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="alertDialog"  max-width="400">
        <v-card>
          <v-card-title>{{confirmTitle}}</v-card-title>
          <v-card-text>
            <p class="mb-3">{{message}}</p>
          </v-card-text>
          <v-card-actions>

            <v-spacer/>
            <v-btn variant="elevated" color="primary" @click="alertDialog = false;"  class="flex-grow-1 flex-shrink-1">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="messageDialog" :color="messageColor" location="top center" close-delay="5000">
        {{ message }}
        <template v-slot:actions>
          <v-btn color="white" variant="text" icon="mdi-close" @click="messageDialog = false"></v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="loading" persistent max-width="200">
        <v-card>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" class="align-content-center align-center justify-center">
                  <v-progress-circular style="left: 50%; margin-left: -16px" indeterminate color="primary"></v-progress-circular>
                  <h3 style="width: 100%; text-align: center">{{loadingMessage}}</h3>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-main>
  </v-app>
</template>

<script lang="ts">
import {defineComponent, ref, computed, watch, onMounted, inject} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import config from './config'
import utils from "./utils"
import type {Messages} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import type {Auth} from "@/plugins/auth.ts";
import type {DrawerItem, Notification} from "@/models.ts";

import logo from './assets/logo-alpha.png'
import logoEsteso from './assets/logo-esteso-alpha.png'
import logoH from './assets/logo-h.png'

export default defineComponent({
  name: 'App',
  setup() {

    const globals = inject('globals') as Globals
    const messages = inject('messages') as Messages
    const auth = inject('auth') as Auth

    const router = useRouter()
    const route = useRoute()

    // Data properties
    const drawer = ref(true)
    const showPwd = ref(false)

    const openGroups = ref<string[]>([])

    
    const pages = computed<DrawerItem[]>(() => {
      let items:DrawerItem[] = [{ title: "Dashboard", icon: "mdi-view-dashboard", link: "/" }];
      if (auth.isEditor.value) {
        items.push(
          {
            title: "Gestione Dati", icon: 'mdi-package-variant', items: [
              { title: "Pacchetti", icon: "mdi-dumbbell", link: "/kits" },
              { title: "Esercizi", icon: "mdi-run-fast", link: "/exercises" },
              { title: "Categorie", icon: "mdi-tag", link: "/categories" },
              { title: "Sottocategorie prodotto", icon: "mdi-tag", link: "/subcategories" },
              { title: "Difficoltà", icon: "mdi-alert", link: "/difficulties" },
              { title: "Generi", icon: "mdi-gender-male-female", link: "/genre" },
              { title: "Media", icon: "mdi-play-network", link: "/media" },
              { title: "Banner", icon: "mdi-advertisements", link: "/banners" },
              { title: "Gallery", icon: "mdi-image-multiple", link: "/gallery" },
            ]
          },
          {
            title: "Gestione App", icon: 'mdi-cellphone-cog', items: [
              { title: "Sezioni Home", icon: "mdi-tablet-dashboard", link: "/home" },
              { title: "Pagine Statiche", icon: "mdi-text", link: "/cms" },
            ]
          },
          {
            title: "Prenotazioni", icon: 'mdi-calendar-month', items: [
              { title: "TopGym Experience", icon: "mdi-calendar-account", link: "/topgymexperience" },
              { title: "Sala Corsi", icon: "mdi-calendar-account", link: "/salacorsi" },
              { title: "Open Gym", icon: "mdi-calendar-account", link: "/opengym" },
              { title: "Bike indoor", icon: "mdi-calendar-account", link: "/gym" },
              { title: "Vacu", icon: "mdi-calendar-account", link: "/vacu" },
              { title: "Visite mediche", icon: "mdi-calendar-account", link: "/medical" },
              { title: "Aperture e Ferie", icon: "mdi-glass-cocktail", link: "/calendar" },
              { title: "Preferenze prenotazioni", icon: "mdi-order-bool-ascending-variant", link: "/bookingprefs" },
            ]
          },
        )
      } else {
        items.push(
          {
            title: "Prenotazioni", icon: 'mdi-calendar-month', items: [
              { title: "TopGym Experience", icon: "mdi-calendar-account", link: "/topgymexperience" },
              { title: "Sala Corsi", icon: "mdi-calendar-account", link: "/salacorsi" },
              { title: "Open Gym", icon: "mdi-calendar-account", link: "/opengym" },
              { title: "Bike indoor", icon: "mdi-calendar-account", link: "/gym" },
              { title: "Vacu", icon: "mdi-calendar-account", link: "/vacu" },
              { title: "Visite mediche", icon: "mdi-calendar-account", link: "/medical" },
            ]
          },
        );
      }

      if (auth.isAdmin.value) {
        items.push(
          { title: "Vendite", icon: "mdi-cart", link: "/sells" },
          { title: "Report utenti", icon: "mdi-format-list-checks", link: "/reports" },
          {
            title: 'Gestione utenti', icon: 'mdi-account-box-multiple', items: [
              { title: "Visite Mediche", icon: "mdi-doctor", link: "/mediche" },
              { title: "Tesserati MSP", icon: "mdi-card-account-details", link: "/cards" },
              { title: "Utenti", icon: "mdi-account", link: "/users" },
            ]
          },
          { title: "Impostazioni", icon: "mdi-cog", link: "/settings" },
        );
      }
      return items
    })
    

    
    const numNotifications = computed(() => {
      if (!auth.user.value || !auth.notifications.value) return 0
      return auth.notifications.value.filter((item: any) => {
        return !item.read_by || !item.read_by.includes(auth.user.value?._id)
      }).length
    })
    
    // Methods
    
    const notificationClass = (notification: any) => {
      if (notification.read_by && notification.read_by.includes(auth.user.value?._id)) {
        return 'text-grey-darken-2 no-select'
      }
      return 'text-primary no-select'
    }
    
    const openNotification = async (notification: Notification) => {
      await auth.setNotificationRead(notification._id!)
      await router.push(notification.link)
    }
    
    const formatDate = utils.formatDateTime
    
    const goHome = () => {
      router.push('/')
    }
    
    const onLoginClick = async () => {
      const err = await auth.login()
      if(err) {
        messages.error(err)
        return
      }
    }
    
    const logout = () => {
      auth.logout()
    }

    
    // Lifecycle hooks
    onMounted(async () => {
      await auth.refreshToken()
      await globals.init()
      await router.isReady()

      let opens:string[] = []
      for(let i = 0; i < pages.value.length; i++) {
        const root = pages.value[i]

        if(!root.items) continue


        for(let j = 0; j < root.items.length; j++) {
          const page = root.items[j];
          if(!page.link) continue;
          if(route.path.startsWith(page.link)) {
            if(!opens.includes(root.title)) {
              opens.push(root.title)
            }
          }

        }

      }

      openGroups.value = opens;


    })
    
    return {
      logo,
      logoEsteso,
      logoH,
      // Data
      drawer,
      showPwd,
      openGroups,
      loginDialog : auth.dialog,
      loginLoading : auth.loading,
      loginEmail : auth.email,
      loginPassword : auth.password,
      loggedIn : auth.isLoggedIn,
      profile : auth.user,

      confirmTitle : messages.title,
      confirmDialog : messages.confirmDialog,
      alertDialog : messages.alertDialog,
      message : messages.message,
      confirmCheckbox : messages.checkbox,
      confirmCheckboxValue : messages.checkboxValue,
      confirmCallback : messages.callback,
      messageDialog : messages.messageDialog,
      messageColor : messages.messageColor,
      loading : messages.loadingDialog,
      loadingMessage : messages.loadingMessage,
      notifications : auth.notifications,
      numNotifications,
      // Computed
      pages,
      // Methods
      notificationClass,
      openNotification,
      formatDate,
      goHome,
      onLoginClick,
      logout,
      areActivePages(pages:DrawerItem[]):boolean {
        for(let i = 0; i < pages.length; i++) {
          const page = pages[i];
          if(page.link && route.path.startsWith(page.link)) return true
        }
        return false
      },
      isActivePage(page:DrawerItem):boolean {
        if(!page.link) return false;
        return route.path.startsWith(page.link)
      }
    }
  }
})
</script>